import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  addressCountries,
  ApiResponse,
  AUTO_EXCLUDE_ADDRESSES,
  Creditors,
  Debtor,
  mapPartyType,
  ReturnAddress,
  SignatureBlock,
  UserUploadedAddresses,
} from '../../utils/constant';
import * as uuid from 'uuid';
import { apiInstance } from '../../api/apiInstance';
import { RootState } from 'src/store/store';

export const formatParties = (data: any) => {
  const partiesArray = data as ApiResponse;
  const formattedParties = partiesArray.caseParties.map((item) => {
    const shouldExcludeItem = data.autoExclusionList.includes(item.name) || item.addresses.every((item) => !item);
    return {
      name: item.name,
      address: item.addresses.filter((item) => item !== null),
      isFirstClass: !shouldExcludeItem,
      isCertified: false,
      isOvernight: false,
      isCmEcf: false,
      id: uuid.v4(),
      partyType: mapPartyType[item.partyType],
      newJerseyRelationshipOfParty: '',
      isExcluded: AUTO_EXCLUDE_ADDRESSES.includes(item.name.toLowerCase()),
      source: 'case_parties',
      email: item.email ?? null,
      addressCountry: item.addressCountry,
    };
  });

  const filteredParties = formattedParties.filter((caseParty) => caseParty.name || caseParty.address[0]);

  return filteredParties;
};

//TODO fix attorneys
export const formatAttorneys = (data: any) => {
  // const attorneyArray = data.case as ApiResponse;
  // return attorneyArray.attorneys.attorneyArray.map((item) => {
  //   const {
  //     streetAddress1,
  //     streetAddress2,
  //     city,
  //     stateCode,
  //     zip,
  //     zip4,
  //     stateName,
  //   } = item.contact.addressArray[0];
  //   const phoneNumber = ""
  //     // item.contact.phoneNumberArray.find(
  //     //   (phone) => phone.phoneType === 'DEFAULT',
  //     // )?.phoneNumber || '';
  //   return {
  //     name: item.name,
  //     address: item.addresses,
  //     isFirstClass: true,
  //     isCertified: false,
  //     isOvernight: false,
  //     // email: item.contact.emailArray[0].emailId,
  //     phoneNumber,
  //     address1: streetAddress1,
  //     city: city,
  //     state: stateName,
  //     zip: zip,
  //     id: uuid.v4(),
  //     relationShopToParty: '',
  //   };
  // });
};

export const formatCreditors = (data: any) => {
  const caseData = data as ApiResponse;
  const creditorsArray = caseData.creditors;

  const seen = new Set();

  const formattedCreditors = creditorsArray.map((item) => {
    const address = [item.name, ...item.addresses].flat().join('');
    const key = address.toLowerCase();

    const shouldExcludeItem =
      data.autoExclusionList.includes(item.name) || item.isUndeliverable || item.addresses.every((item) => item === '');

    const formattedCreditor = {
      name: item.name,
      id: uuid.v4(),
      address: item.addresses,
      isFirstClass: !shouldExcludeItem,
      isCertified: false,
      isOvernight: false,
      isExcluded: false,
      isCmEcf: false,
      isPreferred: item.isPreferred,
      isDuplicate: item.isDuplicate ? item.isDuplicate : seen.has(key) ? true : false,
      isUndeliverable: item.isUndeliverable,
      newJerseyRelationshipOfParty: '',
      descriptor: item.description,
      source: 'master_mailing_matrix',
      addressCountry: item.addressCountry,
    };

    if (!seen.has(key)) {
      seen.add(key);
    }

    return formattedCreditor;
  });

  const filteredCreditors = formattedCreditors.filter(
    (creditor) => (creditor.name[0] || creditor.address[0]) && !creditor.isDuplicate,
  );

  return filteredCreditors;
};

export const format341DebtorData = (data: any) => {
  // const caseData = data.case as ApiResponse;
  // const partyArray = caseData.parties.partyArray;
  // return partyArray
  //   .filter(
  //     (item) =>
  //       item.sourcePartyRole === 'DEBTOR' ||
  //       item.sourcePartyRole === 'JOINT DEBTOR',
  //   )
  //   .map(
  //     (item) =>
  //       ({
  //         name: item.name,
  //         address: [
  //           `${item.contact.addressArray[0].streetAddress1}`,
  //           `${item.contact.addressArray[0].streetAddress2 || ''} ${item.contact.addressArray[0].city}, ${item.contact.addressArray[0].stateCode} ${item.contact.addressArray[0].zip}${item.contact.addressArray[0].zip4 ? '-' + item.contact.addressArray[0].zip4 : ''}`.trim(),
  //         ].filter(Boolean),
  //         id: item.partyId,
  //       }) as Debtor,
  //   );
};

export const format341DebtorTrustee = (data: any) => {
  // const caseData = data.case as ApiResponse;

  // const partyArray = caseData.parties.partyArray;

  // const foundTrustee = partyArray.find(
  //   (item) => item.sourcePartyRole === 'TRUSTEE',
  // );

  // if (foundTrustee) {
  //   return {
  //     name: foundTrustee.name,
  //     address: [
  //       `${foundTrustee.contact.addressArray[0].streetAddress1}`,
  //       `${foundTrustee.contact.addressArray[0].streetAddress2 || ''} ${foundTrustee.contact.addressArray[0].city}, ${foundTrustee.contact.addressArray[0].stateCode} ${foundTrustee.contact.addressArray[0].zip}${foundTrustee.contact.addressArray[0].zip4 ? '-' + foundTrustee.contact.addressArray[0].zip4 : ''}`.trim(),
  //     ].filter(Boolean),
  //     phoneNumber: foundTrustee.contact.phoneNumberArray[0].phoneNumber ?? '',
  //     email:
  //       foundTrustee.contact.addressArray.length > 1
  //         ? foundTrustee.contact.emailArray[0].emailId
  //         : '',
  //     id: foundTrustee.partyId,
  //   };
  // }

  return null;
};

export const fetchCaseInfo = createAsyncThunk(
  'api/fetchData',
  async (
    {
      caseNumber,
      courtState,
      courtDistrict,
      showFetchedCaseFromMultipleChoice,
      jointCaseNumbers,
      includeCaseParties,
      includeCreditors,
    }: {
      caseNumber: string;
      courtState: string;
      courtDistrict?: string;
      showFetchedCaseFromMultipleChoice?: boolean;
      jointCaseNumbers?: { id: string; textfieldValue: string; value: string }[];
      includeCaseParties?: boolean;
      includeCreditors?: boolean;
    },
    { rejectWithValue, getState },
  ) => {
    const hasDistrict = courtDistrict !== 'A' && courtDistrict !== '' && courtDistrict !== 'Add...';
    const state = getState() as RootState;

    const params = new URLSearchParams();
    params.append('courtState', courtState);
    params.append('caseNumber', caseNumber);
    if (jointCaseNumbers && jointCaseNumbers.length > 0) {
      for (let caseNumber of jointCaseNumbers) {
        params.append('caseNumber', caseNumber.value);
      }
    }
    if (hasDistrict) {
      params.append('courtDistrict', courtDistrict!);
    }
    if (includeCaseParties) {
      params.append('includeCaseParties', 'true');
    }
    if (includeCreditors) {
      params.append('includeCreditors', 'true');
    }

    try {
      const { data } = await apiInstance.get(`/court/case?${params}`);

      return {
        ...data,
        caseNumber,
        showFetchedCaseFromMultipleChoice,
        autoExclusionList: [
          ...(state.user.currentUser?.thirteenTrusteeAddressExclusions ?? []),
          ...AUTO_EXCLUDE_ADDRESSES,
        ],
      };
    } catch (error: any) {
      return rejectWithValue({
        message: error.response.data.message,
        clientCode: error.response.data.clientCode,
      });
    }
  },
);

export const sendDataForProcessing = createAsyncThunk(
  'api/sendDataForProcess',
  async (data: void | FormData | null, { rejectWithValue }) => {
    try {
      let resp = await apiInstance.post('/job', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return resp;
    } catch (error: any) {
      if (error.response.data.errorStack) {
        return rejectWithValue(error.response.data.errorStack);
      } else {
        return rejectWithValue([error.response.data.message]);
      }
    }
  },
);

export const addReturnAddressToDb = createAsyncThunk('api/addReturnAddress', async (returnAdd: ReturnAddress) => {
  let resp = await apiInstance.post('/profile/return-addresses', {
    ...returnAdd,
  });

  const address = { ...resp.data, selected: true };

  return address;
});

export const editReturnAddressInDb = createAsyncThunk('api/editReturnAddressInDb', async (returnAdd: ReturnAddress) => {
  let resp = await apiInstance.put('/profile/return-addresses', {
    ...returnAdd,
  });

  return returnAdd;
});

export const removeReturnAddressInDb = createAsyncThunk('api/removeReturnAddressInDb', async (returnId: string) => {
  await apiInstance.delete(`/profile/return-addresses/${returnId}`);

  return returnId;
});

export const getReturnAddresses = createAsyncThunk('/api/getReturnAddresses', async () => {
  let resp = await apiInstance.get('/profile/return-addresses');

  return resp.data;
});

export const getUserCertificates = createAsyncThunk('/api/getUserCertificates', async () => {
  let resp = await apiInstance.get('/profile/signatures');

  return resp.data;
});

export const addCertificate = createAsyncThunk('api/addCertificate', async (signature: SignatureBlock) => {
  const formattedSignature = Object.fromEntries(Object.entries(signature).map(([k, v]) => [k, v === '' ? null : v]));
  let resp = await apiInstance.post('/profile/signatures', {
    ...formattedSignature,
  });

  return { ...resp.data, selected: true };
});

export const editCertificatesInDB = createAsyncThunk('api/editCertificatesInDB', async (signature: SignatureBlock) => {
  const formattedSignature = Object.fromEntries(Object.entries(signature).map(([k, v]) => [k, v === '' ? null : v]));
  await apiInstance.put('/profile/signatures', {
    ...formattedSignature,
  });

  return signature;
});

export const removeCertificate = createAsyncThunk('api/removeCertificate', async (certificateId: string) => {
  let resp = await apiInstance.delete(`/profile/signatures/${certificateId}`);

  return certificateId;
});

export const processUserSuppliedAddress = createAsyncThunk(
  'api/processUserSuppliedAddress',
  async (files: File[], { getState, rejectWithValue }) => {
    const formData = new FormData();
    const state = getState() as RootState;

    files.forEach((file: File) => {
      formData.append('files', file);
    });

    try {
      let resp = await apiInstance.post(`/job/process-addresses`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      let data = resp.data;
      const autoExclusionList = [
        ...(state.user.currentUser?.thirteenTrusteeAddressExclusions ?? []),
        ...AUTO_EXCLUDE_ADDRESSES,
      ];
      // Strings that, when they appear alone as the last address line, indicate
      // United States. Matches the backend's last-line-country.pipe.ts US entries.
      // Case-insensitive, whole-line only — "123 United States" does NOT match.
      const US_COUNTRY_TOKENS = new Set([
        'united states', 'united states of america',
        'usa', 'us', 'u.s.', 'u.s.a.', 'america',
        'puerto rico', 'pr', 'guam', 'gu',
        'u.s. virgin islands', 'us virgin islands', 'virgin islands',
        'american samoa', 'northern mariana islands',
      ]);

      const addresses = data
        .filter((item: UserUploadedAddresses) => item.address.length > 0)
        .map((item: UserUploadedAddresses) => {
          const shouldExcludeItem = autoExclusionList.includes(item.name) || item.address.length === 0;

          const lastLine = (item.address ?? []).at(-1) ?? '';
          const lastLineTrimmedLower = lastLine.trim().toLowerCase();
          const lastLineIsUSToken = US_COUNTRY_TOKENS.has(lastLineTrimmedLower);

          // The last line is a non-US country if it appears in the addressCountries
          // dropdown list AND is not one of the US tokens.
          const isNonUSCountry = !lastLineIsUSToken
            && addressCountries.some((c) => c.toLowerCase() === lastLineTrimmedLower);

          // Count content lines — exclude anything that is a known country indicator
          // (both the addressCountries dropdown list AND all US token variations).
          const contentLines = (item.address ?? []).filter((l) => {
            const lower = l.trim().toLowerCase();
            return !US_COUNTRY_TOKENS.has(lower)
              && !addressCountries.some((c) => c.toLowerCase() === lower);
          });
          // For US addresses: strip the last line only when it is exclusively a US
          // country token AND the content lines are exactly at the 5-line limit —
          // meaning the token would be a redundant 6th printed line. If content lines
          // are under the limit, the token is within range and must be kept as-is.
          const strippedAddress = (lastLineIsUSToken && contentLines.length >= 5)
            ? (item.address ?? []).slice(0, -1)
            : item.address;

          // For non-US addresses the country line occupies one printable slot,
          // so the effective limit is 4 content lines (4 + 1 country = 5 total).
          // For US addresses (no country line) the limit is 5 content lines.
          const effectiveLimit = isNonUSCountry ? 4 : 5;
          const isTooManyLines = contentLines.length > effectiveLimit ? true : undefined;
          return {
            ...item,
            address: strippedAddress,
            isFirstClass: shouldExcludeItem ? false : item.isFirstClass,
            isCmEcf: shouldExcludeItem ? false : item.isCmEcf,
            source: 'user_supplied',
            isTooManyLines,
          };
        });

      return addresses;
    } catch (err: any) {
      return rejectWithValue(err.response.data.message);
    }
  },
);

export const checkAvailableServiceOptions = createAsyncThunk('/api/checkAvailableServiceOptions', async () => {
  let resp = await apiInstance.get('/job/submit-rules');

  return resp.data;
});
